import { Select } from '@bloomfieldrobotics/canopy';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  EnvironmentEnum,
  environmentOptions,
  selectEnvironment,
  setEnvironment,
} from '../apiExplorerSlice';

const EnvironmentDropdown: React.FC = () => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(selectEnvironment);

  const handleChange = (value: EnvironmentEnum) => {
    dispatch(setEnvironment(value));
  };

  return (
    <Select
      options={environmentOptions}
      value={value}
      onChange={handleChange}
    />
  );
};

export default EnvironmentDropdown;
